/* eslint-disable */
import qs from "qs";
import axios from "../common/cotAxios";
import { UpdateUserList, UserItems, UserLogin } from "./User";

export default {
    Authn(email: any, mttms: any): Promise<any> {
        console.log("Authrequest:", email, mttms)
        return axios.post("/api/authnUser", {
            email: email,
            mttms: mttms
        })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },
    Auth(email: any, password: any): Promise<any> {
        console.log("Authrequest:", email, password)
        return axios.post("/api/auth", {
            email: email,
            password: password
        }, {
            withCredentials: true,
        })
            .then(({ data }) => data);
    },
    // ユーザーサインイン
    GetUser(email: string): Promise<any> {
        console.log("ready to login:", email)
        return axios.post("/api/login", {
            email: email
        }, {
            withCredentials: true
        }
        )
            .then(({ data }) => data);
    },
    // GetUser(user: UserLogin): Promise<any> {
    //     console.log("ready to login:", user)
    //     return axios.post("/api/login", {
    //             email: user.email,
    //             fullName: user.fullName,
    //             isNew: user.isNew,
    //             profileImageUrl: user.profileImageUrl,
    //             organization: user.organization,
    //             localAccountId: user.localAccountId
    //        }
    //         )
    //         .then(({data}) => data)
    //         .catch((error) => {return error});
    //},
    // ユーザーサインアウト
    SignOut(): Promise<any> {
        return axios.get("/api/saml/logout")
            .then(({ data }) => data)
            .catch((error) => { return error });
    },
    //ユーザ情報の取得
    GetUserInfoList(): Promise<any> {
        return axios.get("/api/getUserInfoList", {
            withCredentials: true
        })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },

    Logout(): Promise<any> {
        return axios.get("/api/logout", {
            withCredentials: true
        })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },
    //ユーザ情報の更新
    UpdateUserInfo(updateListItems: UpdateUserList[]): Promise<any> {
        const params = new FormData();
        let sendUserDataList = "";
        updateListItems.map((row) => {
            params.append("files", row.imageFile === null || row.imageFile === undefined ? new File([""], "empty") : row.imageFile);

            if (sendUserDataList !== "") {
                sendUserDataList = sendUserDataList + "," + JSON.stringify({
                    id: row.id,
                    fullName: row.fullName,
                    skills: row.skills,
                    roles: row.roles
                });
            }
            else {
                sendUserDataList = JSON.stringify({
                    id: row.id,
                    fullName: row.fullName,
                    skills: row.skills,
                    roles: row.roles
                });
            }
            return null;
        });
        params.append("userInfo", new Blob([sendUserDataList], { type: "application/json" }));

        return axios.post("/api/updateUserInfo", params,
            {
                headers: { "content-type": "multipart/form-data" },
                withCredentials: true
            })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },

    // ユーザープロファイル画像の更新
    UpdateUserImage(imageFile: any, profileItems: UserItems): Promise<any> {
        const params = new FormData();
        console.log('test:', imageFile, typeof (imageFile))
        console.log('test:', profileItems)
        params.append("file", imageFile);
        params.append("userProfile", new Blob([JSON.stringify(profileItems)], { type: "application/json" }));
        return axios.post("/api/updateUserProfileImage", params,
            {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },

    //スキルの取得、検索
    GetSkillList(inputSkillList: string[]): Promise<any> {
        return axios.get("/api/getSkillList", { params: { skills: inputSkillList[0] } })
            .then(({ data }) => data)
            .catch((error) => { return error });
    },

    // ユーザー情報同期バッチを実行
    StartSyncBatch(): Promise<any> {
        return axios.post("/api/autoUserAzureToXenera")
            .then(({ data }) => data)
            .catch((error) => { return error });
    },

    // トークン検証API
    verifyToken: async (accessToken: string, userLogin: UserLogin): Promise<any> => {
        const response = await axios.post('/api/auth/validate-token', userLogin, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        });
        return response.data;
    },

    // ユーザー情報取得API
    getUserProfile: async (authToken: string): Promise<any> => {
        const response = await axios.get('/user/profile', {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });
        return response.data;
    },

};
